import { Blockquote, createStyles, useMantineTheme } from "@mantine/core"
import { Error404 } from "tabler-icons-react"
import DefaultContainer from "../components/container"

const useStyles = createStyles((theme) => ({
    container: {
        margin: 'auto'
    }
}))

const NotFound = () => {
    const { classes } = useStyles()
    const theme = useMantineTheme()
    return (
        <DefaultContainer>
            <div className={classes.container}>
                <Blockquote icon={<Error404 color={theme.colors.hkc[1]}/>}
                    cite={'If the situation continous, please contact IT support.'}>
                    {`Opps! The page is not found.`}
                </Blockquote>
            </div>
        </DefaultContainer>
    )
}

export default NotFound